import type { IconFolderFilled } from "@tabler/icons-react";

/* ──────────────────────────────────────────────────────────────────────────
   The node editor's two icon helpers, element for element.

   The upload system drew Tabler's filled icons (@tabler/icons-react 3.44.0,
   from esm.sh) through SvgIcon. Signet's copy of the package is 3.48.0; the
   harness compared every filled icon the editor uses between the two and
   their paths are identical, so they are imported from it directly. Only the
   class names carry the module's prefix.
   ────────────────────────────────────────────────────────────────────────── */

export type TablerIcon = typeof IconFolderFilled;

export function SvgIcon({ icon: Icon, className = "", size = 16, title }: { icon: TablerIcon | null | undefined; className?: string; size?: number; title?: string }) {
  if (!Icon) return null;
  return <Icon className={`up-svg-icon ${className}`.trim()} size={size} title={title} aria-hidden={title ? undefined : true} focusable="false" />;
}

export function IconLabel({ icon, label }: { icon: TablerIcon; label: string }) {
  return (
    <span className="up-icon-label">
      <SvgIcon icon={icon} />
      {label}
    </span>
  );
}
